<template>
  <div class="user-wrp-comments mydorm-galeri">         
    <div class="galeri-wrp">
      <div class="row">
        <div class="col-xs-12 col-md-8 galeri-left">
          <div class="galeri-left-wrp">             
            <div class="galeri-left__item" :class="{active: item.isActive}" v-for="item in gallery" :key="item.id"
                 @click="doActive(item)">
              <img class="galeri-left__item-img" :src="item.filename" alt="">
            </div>
          </div>
        </div>
              </div>
        <file-upload
          class="btn btn-primary"
          post-action="/upload/post"
          extensions="gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp"
          :multiple="true"
          :size="1024 * 1024 * 10"
          v-model="gallery"
          @input-filter="inputFilter"
          @input-file="inputFile"
          ref="upload">
          <i class="fa fa-plus"></i>
          Select Image
        </file-upload>        

    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
export default {
  name: 'MyDormGaleriCover',
  components: {
    FileUpload
  },   
  props: {
    gallery: Array,
  },  
  data () {
    return {
      currentItem: null,
      showMmodal: false,
      isActive: false
    }
  },
  methods: {    
    handleImages(e) {
      let selectedFlies = e.target.files;
      if (!selectedFlies.length) {
        return false;
      }
      for (let i = 0; i < selectedFlies.length; i++) {
        this.gallery.push(selectedFlies[i]);
      }
    },    
  }

}
</script>

<style lang="scss">
  @import "../assets/scss/components/mydorm-galeri";
</style>
